export default "__VITE_ASSET__DuMANAtE__"